export const ARROW_WIDTH = 25;
